export default "__VITE_ASSET__BVRgH2Jh__"